var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav nav-stacked"},[_vm._l((_vm.departments),function(department){return _c('departments-dropdown-item',{key:department.id,attrs:{"department":department}})}),_vm._v(" "),_c('li',[_c('router-link',{staticStyle:{"color":"#ffffff"},attrs:{"to":{name: 'about'}}},[_vm._v("About")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }